/**
 * Icona di ogni famiglia di attributi, da usare in tutta l'app accanto al
 * nome della famiglia o al suo posto. Quando sta da sola porta il nome come
 * etichetta accessibile e come suggerimento al passaggio del mouse.
 */

import type { ComponentProps } from 'react';
import { goalNet } from '@lucide/lab';
import {
  BicepsFlexed,
  Brain,
  createLucideIcon,
  Sigma,
  SportShoe,
  type LucideIcon,
} from 'lucide-react';
import { ETICHETTA_FAMIGLIA_ATTRIBUTO, type FamigliaAttributo } from '@calcio/shared';

const GoalNet = createLucideIcon('goal-net', goalNet);

const ICONA_FAMIGLIA: Record<FamigliaAttributo, LucideIcon> = {
  fisici: BicepsFlexed,
  tecnici: SportShoe,
  mentali: Brain,
  portiere: GoalNet,
};

/**
 * L'overall, la media delle medie di famiglia: non e una famiglia, ma sta
 * accanto alle famiglie e si riconosce allo stesso modo, con la Σ della sintesi.
 */
export function IconaOverall(props: ComponentProps<LucideIcon>) {
  const nome = 'Overall';
  return (
    <Sigma role="img" aria-label={nome} {...props}>
      <title>{nome}</title>
    </Sigma>
  );
}

export function IconaFamiglia({
  famiglia,
  ...props
}: { famiglia: FamigliaAttributo } & ComponentProps<LucideIcon>) {
  const Icona = ICONA_FAMIGLIA[famiglia];
  const nome = ETICHETTA_FAMIGLIA_ATTRIBUTO[famiglia];
  return (
    <Icona role="img" aria-label={nome} {...props}>
      <title>{nome}</title>
    </Icona>
  );
}
